import React from "react";
import Toast from "react-bootstrap/Toast";
import { FormattedMessage, MessageDescriptor } from "react-intl";
import { toastMessages } from "../messages";
import { StyledToast } from "./styles";

export interface MessageToastProps {
  show: boolean;
  message?: MessageDescriptor;
  status?: "success" | "error" | "warning";
  onClose?: () => void;
}

export const MessageToast = ({
  onClose,
  show = true,
  message,
  status = "success",
}: MessageToastProps & { onClose: () => void }) => {
  return message ? (
    <StyledToast
      onClose={onClose}
      show={show}
      delay={5000}
      autohide
      status={status}
      className="fixed-bottom ml-10 mb-5">
      <Toast.Header data-status={status}>
        <strong className="me-auto">
          {
            status === "success"
              ? (<FormattedMessage {...toastMessages.genericSuccess} />)
              : status === "warning"
                ? (<FormattedMessage {...toastMessages.genericWarning} />)
                : (<FormattedMessage {...toastMessages.genericError} />)
          }
        </strong>
      </Toast.Header>
      <Toast.Body>
        <FormattedMessage {...message} />
      </Toast.Body>
    </StyledToast>
  ) : <></>;
};
